import "./AboutStyle.css";

const About = () => {
  const frontendSkills = [
    { name: "ReactJS", icon: "fa-code", level: 95 },
    { name: "Angular", icon: "fa-code", level: 85 },
    { name: "HTML5", icon: "fa-html5", level: 99 },
    { name: "CSS3", icon: "fa-css3", level: 99 },
    { name: "Bootstrap", icon: "fa-bold", level: 99 },
  ];
  const backendSkills = [
    { name: "Java", icon: "fa-coffee", level: 90 },
    { name: "Springboot", icon: "fa-leaf", level: 85 },
    { name: "NodeJS", icon: "fa-code", level: 86 },
    { name: "ExpressJS", icon: "fa-server", level: 85 },
    { name: "Groovy & Grails", icon: "fa-github-alt", level: 70 },
  ];

  const otherSkills = [
    { name: "GitHub", icon: "fa-github", level: 97 },
    { name: "Docker", icon: "fa-cube", level: 65 },
    { name: "AWS", icon: "fa-cloud", level: 70 },
    { name: "SQL", icon: "fa-database", level: 85 },
    { name: "MongoDB", icon: "fa-shield", level: 85 },
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <header className="hero-section text-white">
        <div className="container py-5">
          <div className="row align-items-center min-vh-50 py-5">
            <div className="col-lg-6">
              <h1 className="display-3 fw-bold mb-3">
                <span className="text-gradient">Full Stack</span> Developer
              </h1>
              <p className="lead mb-4">
                <i className="fa fa-terminal me-2"></i>
                Building seamless digital experiences from front to back
              </p>

              <div className="d-flex gap-3">
                <a
                  href="#about"
                  smooth
                  className="btn btn-light btn-lg px-4 rounded-pill"
                  style={{ zIndex: 9999 }}
                >
                  Explore My Journey
                </a>
                <a
                  href="#skills"
                  smooth
                  className="btn btn-outline-light btn-lg px-4 rounded-pill"
                  style={{ zIndex: 9999 }}
                >
                  View Skills
                </a>
              </div>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <div className="floating-icons">
                <i className="fa fa-react floating-icon icon-1"></i>
                <i className="fa fa-java floating-icon icon-2"></i>
                <i className="fa fa-database floating-icon icon-3"></i>
                <i className="fa fa-cloud floating-icon icon-4"></i>
                <div className="hero-image-placeholder rounded-circle"></div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* About Section */}
      <section id="about" className="py-5 bg-light">
        <div className="container py-5">
          <div className="row g-5 align-items-center">
            <div className="col-lg-5">
              <div className="about-image p-4">
                <div className="position-relative">
                  <div className="main-image rounded-4 shadow"></div>
                  <div className="experience-badge bg-primary text-white rounded-pill py-2 px-3">
                    <i className="fa fa-star me-2"></i>
                    6+ Years Experience
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <h2 className="section-title mb-4">
                <span className="text-primary">About</span> Me
              </h2>
              <p className="lead text-muted mb-4">
                I architect and build complete web solutions with expertise
                across the entire stack.
              </p>

              <div className="about-content">
                <div className="d-flex mb-3">
                  <div className="icon-box bg-primary bg-opacity-10 text-primary me-3">
                    <i className="fa fa-laptop"></i>
                  </div>
                  <div>
                    <h5>Frontend Development</h5>
                    <p className="text-muted mb-0">
                      I create responsive, accessible interfaces using React,
                      Angular, and modern CSS frameworks.
                    </p>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div className="icon-box bg-primary bg-opacity-10 text-primary me-3">
                    <i className="fa fa-server"></i>
                  </div>
                  <div>
                    <h5>Backend Development</h5>
                    <p className="text-muted mb-0">
                      I design robust APIs and server-side logic with Java,
                      Spring Boot, Node.js and other technologies.
                    </p>
                  </div>
                </div>

                <div className="d-flex">
                  <div className="icon-box bg-primary bg-opacity-10 text-primary me-3">
                    <i className="fa fa-cogs"></i>
                  </div>
                  <div>
                    <h5>DevOps & Deployment</h5>
                    <p className="text-muted mb-0">
                      I implement CI/CD pipelines, containerization, and cloud
                      solutions for scalable applications.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Skills Section */}
      <section id="skills" className="py-5">
        <div className="container py-5">
          <div className="text-center mb-5">
            <h2 className="section-title">
              My <span className="text-primary">Skills</span>
            </h2>
            <p className="lead text-muted">
              Technologies I've mastered through projects and experience
            </p>
          </div>

          <div className="row g-4">
            {[frontendSkills, backendSkills, otherSkills].map(
              (skillGroup, i) => (
                <div key={i} className="col-md-4">
                  <div
                    className={`skill-category card h-100 border-0 shadow-sm`}
                  >
                    <div
                      className={`card-header text-white ${
                        i === 0
                          ? "bg-primary"
                          : i === 1
                          ? "bg-success"
                          : "bg-info"
                      }`}
                    >
                      <h4 className="mb-0">
                        <i
                          className={`fa ${
                            i === 0
                              ? "fa-desktop"
                              : i === 1
                              ? "fa-server"
                              : "fa-tools"
                          } me-2`}
                        ></i>
                        {i === 0 ? "Frontend" : i === 1 ? "Backend" : "Other"}
                      </h4>
                    </div>
                    <div className="card-body">
                      {skillGroup.map((skill, idx) => (
                        <div key={idx} className="mb-3">
                          <div className="d-flex justify-content-between mb-1">
                            <span>
                              <i className={`fa ${skill.icon} me-2`}></i>
                              {skill.name}
                            </span>
                            <span>{skill.level}%</span>
                          </div>
                          <div className="progress" style={{ height: "8px" }}>
                            <div
                              className={`progress-bar ${
                                i === 0
                                  ? "bg-primary"
                                  : i === 1
                                  ? "bg-success"
                                  : "bg-info"
                              }`}
                              role="progressbar"
                              style={{ width: `${skill.level}%` }}
                              aria-valuenow={skill.level}
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </section>

      {/* Experience Section */}
      <section className="py-5 bg-dark text-white">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 className="section-title mb-5">
                My <span className="text-primary">Development</span> Approach
              </h2>
              <div className="timeline">
                <div className="timeline-item">
                  <div className="timeline-icon">
                    <i className="fa fa-lightbulb-o"></i>
                  </div>
                  <div className="timeline-content">
                    <h5>Problem Solving</h5>
                    <p>
                      I break down complex problems into manageable components
                      and architect efficient solutions.
                    </p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-icon">
                    <i className="fa fa-code"></i>
                  </div>
                  <div className="timeline-content">
                    <h5>Clean Code</h5>
                    <p>
                      I write maintainable, well-documented code following best
                      practices and design patterns.
                    </p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-icon">
                    <i className="fa fa-rocket"></i>
                  </div>
                  <div className="timeline-content">
                    <h5>Performance Focus</h5>
                    <p>
                      I optimize applications for speed, scalability, and
                      excellent user experience.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
